export default {
  title: "Motivo Baja"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , oob: {
      label: "¿Aplica OOB?"
      , th: "OOB"
    }
  }
  , errors: {
    BD5025: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , WS5025: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , JS5025: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , CR5025: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , UK_Acuerdo: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/motivobaja.js